export function getSectionLayoutSettings(sectionOrSettings = {}) {
  const settings = sectionOrSettings.settings || sectionOrSettings || {}

  const columns = Number(settings.columns ?? 2)
  const rows = Number(settings.rows ?? 2)
  const gap = Number(settings.gap ?? 16)
  const productsToShow = Number(
    settings.productsToShow ?? settings.limit ?? (columns * rows)
  )

  return {
    columns,
    rows,
    gap,
    productsToShow
  }
}